module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Interpolated Multipliers",
      "icon": "interpolated"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Ogden Table"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ogdenTable),
      expression: "ogdenTable"
    }],
    ref: "ogdenTable",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ogdenTable = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.reCalculateMultiplier()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                        Please select...\n                    ")]), _vm._v(" "), _vm._l((_vm.ogdenTableInfo.tables), function(item, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                        " + _vm._s(key.charAt(0).toUpperCase() + key.slice(1).replace('-', ' ')) + "\n                        -\n                        " + _vm._s(item.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Discount Rate"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountRate),
      expression: "discountRate"
    }],
    ref: "discountRate",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discountRate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.reCalculateMultiplier()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                        Please select...\n                    ")]), _vm._v(" "), _vm._l((_vm.ogdenTableInfo.columns), function(item, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                        " + _vm._s(item) + "%\n                    ")])
  })], 2)]), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ogdenTable !== 'table-28'),
      expression: "ogdenTable!=='table-28'"
    }],
    attrs: {
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }],
    ref: "dateOfBirth",
    attrs: {
      "name": "date_of_birth",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.reCalculateMultiplier()
      }
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_birth')
    }
  }, [_vm._v("\n                    Date of Birth is required\n                ")])], 1), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ogdenTable !== 'table-28'),
      expression: "ogdenTable!=='table-28'"
    }],
    attrs: {
      "for": "age_of_deceased",
      "label": "Date of Trial"
    }
  }, [_c('date-input', {
    ref: "dateOfTrial",
    attrs: {
      "disabled": _vm.dateOfBirth === null || _vm.dateOfBirth === ''
    },
    on: {
      "input": function($event) {
        return _vm.reCalculateMultiplier()
      }
    },
    model: {
      value: (_vm.dateOfTrial),
      callback: function($$v) {
        _vm.dateOfTrial = $$v
      },
      expression: "dateOfTrial"
    }
  })], 1), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ogdenTable !== 'table-28'),
      expression: "ogdenTable!=='table-28'"
    }],
    attrs: {
      "label": "Age at Trial"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ageAtTrial),
      expression: "ageAtTrial"
    }],
    ref: "ageAtTrial",
    attrs: {
      "autocomplete": "off",
      "name": "age_of_deceased",
      "disabled": _vm.dateOfBirth === null || _vm.dateOfBirth === ''
    },
    domProps: {
      "value": (_vm.ageAtTrial)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtTrial = $event.target.value
      }, function($event) {
        return _vm.reCalculateMultiplier()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isValidAgeAtTrial()
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.ageAtTrialValidationMessage()) + "\n                ")])], 1), _vm._v(" "), _c('control', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ogdenTable === 'table-28'),
      expression: "ogdenTable==='table-28'"
    }],
    attrs: {
      "label": "Term"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    ref: "term",
    attrs: {
      "autocomplete": "off",
      "name": "age_of_deceased"
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }, function($event) {
        return _vm.reCalculateMultiplier()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.isValidTerm()
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.termValidationMessage()) + "\n                ")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Interpolated Multiplier"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    domProps: {
      "value": _vm.roundValue(_vm.multiplier, 2)
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.multiplier > 0),
      expression: "multiplier > 0"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [(_vm.multiplier) ? _c('div', [_c('h2', [_vm._v("Explanation")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.ogdenTableInfo.tables[_vm.ogdenTable].name) + " are calculated using Ogden " + _vm._s(_vm.ogdenTable.charAt(0).toUpperCase() + _vm.ogdenTable.slice(1).replace('-', ' ')) + ".\n                ")]), _vm._v(" "), (_vm.tableData.table.tbody.length === 1) ? _c('p', [_vm._v("\n                    Since the person's age at trial is a round figure, " + _vm._s(_vm.ageAtTrial) + " years old, an exact row can be found within the Ogden Table.\n                    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                    Using the discount rate of " + _vm._s(_vm.discountRate) + "% we can determine the multiplier value to be "), _c('strong', [_vm._v(_vm._s(_vm.roundValue(_vm.multiplier, 2)))])]) : _c('p', [_vm._v("\n                    Since the person's age at trial is not a round figure, " + _vm._s(_vm.ageAtTrial) + " years old, an exact row of the Ogden Table is not available. Therefore, we must\n                    use the nearest two rows and interpolate the figure from between them.\n                    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                    Using the discount rate of " + _vm._s(_vm.discountRate) + "% and interpolating between the two values the multiplier value can be found to be "), _c('strong', [_vm._v(_vm._s(_vm.roundValue(_vm.multiplier, 2)))])]), _vm._v(" "), (_vm.tableData !== null) ? _c('div', {
    staticClass: "a-table--really-wide"
  }, [_c('table', {
    staticClass: "a-table a-table--full-width a-table--modal"
  }, [_c('thead', [_c('tr', _vm._l((_vm.tableData.table.thead), function(column) {
    return _c('th', [_vm._v("\n                                " + _vm._s(column) + "\n                            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.table.tbody), function(row) {
    return _c('tr', _vm._l((row), function(column) {
      return _c('td', [_vm._v("\n                                " + _vm._s(column) + "\n                            ")])
    }), 0)
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.tableData.table.tbody.length > 1) ? _c('div', [_c('h2', [_vm._v("Calculation")]), _vm._v(" "), _c('p', [_vm._v("\n                        The person's age at the assumed date of trial is " + _vm._s(_vm.ageAtTrial) + " years old which, as it is not a round figure, lies between rows " + _vm._s(_vm.formulaData()[0]) + "\n                        and " + _vm._s(_vm.formulaData()[2]) + " of Ogden Table\n                        " + _vm._s(_vm.ogdenTable.charAt(0).toUpperCase() + _vm.ogdenTable.slice(1).replace('-', ' ')) + ".\n                        Therefore, interpolation between rows " + _vm._s(_vm.formulaData()[0]) + " and " + _vm._s(_vm.formulaData()[2]) + " is\n                        required on the " + _vm._s(_vm.discountRate) + "% column to receive the projected mortality value:\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_vm._v("\n                            " + _vm._s(_vm.formulaData()[3]) + " + ((" + _vm._s(_vm.formulaData()[2]) + " - " + _vm._s(_vm.ageAtTrial || _vm.term) + ") x (" + _vm._s(_vm.formulaData()[1]) + " - " + _vm._s(_vm.formulaData()[3]) + ")) = " + _vm._s(_vm.roundValue(_vm.multiplier, 2)) + "\n                        ")])])]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-487d41af!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/InterpolatedMultipliers.vue
// module id = 1672
// module chunks = 0